import { AppRoute } from './types'
import {
  PrintoutListPage,
  FavoritePrintoutsPage,
  ToSendPrintoutsPage,
} from './pages'

import { PRINTOUT_ROUTES } from './routes-typed'

export const printoutsRoutesMap: Record<string, string> = {
  printoutList: PRINTOUT_ROUTES.printoutList.path,
  printoutListWithDateRange: PRINTOUT_ROUTES.printoutListWithDateRange.path,
  favoritePrintouts: PRINTOUT_ROUTES.favoritePrintouts.path,
  toSendPrintouts: PRINTOUT_ROUTES.toSendPrintouts.path,
  scheduledPrintouts: PRINTOUT_ROUTES.scheduledPrintouts.path,
}

export const printoutsRoutes: AppRoute[] = [
  {
    path: printoutsRoutesMap.printoutListWithDateRange,
    exact: false,
    component: PrintoutListPage,
    heightScreen: true,
    navigation: false,
  },
  {
    path: printoutsRoutesMap.printoutList,
    component: PrintoutListPage,
    heightScreen: true,
    navigation: false,
  },
  {
    path: printoutsRoutesMap.favoritePrintouts,
    heightScreen: true,
    component: FavoritePrintoutsPage,
    navigation: false,
  },
  {
    path: printoutsRoutesMap.toSendPrintouts,
    heightScreen: true,
    component: ToSendPrintoutsPage,
    navigation: false,
  },

]
